import React from 'react';

const Footer = () => {
    return (
        <footer>
            <small>&copy; Made by Jenni at BCH Full Stack Developer program</small>
        </footer>
    );
};

export default Footer;